// extracted by mini-css-extract-plugin
module.exports = {"CommomImage":"CommonImage_CommomImage__QsWVe"};